import { useId } from "react";

const GOOGLE_PLAY = "googlePlay";
const APP_STORE = "appStore";

const OngroundStoreIcon = ({
  platform,
  className = "",
  monochromeColor = "currentColor",
}) => {
  const generatedId = useId().replace(/[^A-Za-z0-9_-]/g, "");
  const gradientPrefix = `onground-google-play-${generatedId || "icon"}`;

  if (platform === GOOGLE_PLAY) {
    const gradientOne = `${gradientPrefix}-one`;
    const gradientTwo = `${gradientPrefix}-two`;
    const gradientThree = `${gradientPrefix}-three`;
    const gradientFour = `${gradientPrefix}-four`;

    return (
      <svg
        viewBox="0 0 24 24"
        width="28"
        height="28"
        className={className}
        fill="none"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M3.18 1.13C2.47 1.56 2 2.33 2 3.22v17.56c0 .89.47 1.66 1.18 2.09l.1.06 9.83-9.83v-.23L3.28 3.07l-.1.06z"
          fill={`url(#${gradientOne})`}
        />
        <path
          d="M16.41 16.44l-3.27-3.27v-.23l3.27-3.27.07.04 3.88 2.2c1.11.63 1.11 1.66 0 2.3l-3.88 2.2-.07.03z"
          fill={`url(#${gradientTwo})`}
        />
        <path
          d="M16.48 16.41l-3.34-3.34-9.96 9.96c.37.39.92.44 1.55.1l11.75-6.72"
          fill={`url(#${gradientThree})`}
        />
        <path
          d="M16.48 9.59L4.73 2.87c-.63-.35-1.18-.3-1.55.1l9.96 9.96 3.34-3.34z"
          fill={`url(#${gradientFour})`}
        />
        <defs>
          <linearGradient
            id={gradientOne}
            x1="15.83"
            y1="12"
            x2="2"
            y2="12"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00A0FF" />
            <stop offset="1" stopColor="#00BEFF" />
          </linearGradient>
          <linearGradient
            id={gradientTwo}
            x1="21.8"
            y1="11.94"
            x2="12.5"
            y2="11.94"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD000" />
            <stop offset="1" stopColor="#FF9600" />
          </linearGradient>
          <linearGradient
            id={gradientThree}
            x1="17.2"
            y1="13.38"
            x2="1.46"
            y2="28.92"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF3A44" />
            <stop offset="1" stopColor="#C31162" />
          </linearGradient>
          <linearGradient
            id={gradientFour}
            x1="0.81"
            y1="-1.52"
            x2="10.18"
            y2="7.72"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#32A071" />
            <stop offset="1" stopColor="#2DA771" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (platform === APP_STORE) {
    return (
      <svg
        viewBox="0 0 24 24"
        width="28"
        height="28"
        className={className}
        fill="currentColor"
        style={{ color: monochromeColor }}
        aria-hidden="true"
        focusable="false"
      >
        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
      </svg>
    );
  }

  return null;
};

export default OngroundStoreIcon;
